// extracted by mini-css-extract-plugin
export default {"root":"SettingsView_root__58wqm","title":"SettingsView_title__xr7Jw","wrapper":"SettingsView_wrapper__tgKU+","card":"SettingsView_card__4gbcR"};